function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M8.44,39.12h-.9A11.67,11.67,0,0,1,5.67,39,5.86,5.86,0,0,1,4,38.4a4.93,4.93,0,0,1-1.39-1,5.12,5.12,0,0,1-1-1.4,5.69,5.69,0,0,1-.55-1.66A11.7,11.7,0,0,1,.9,32.47V7.55a11.7,11.7,0,0,1,.16-1.87A5.6,5.6,0,0,1,1.6,4a5.12,5.12,0,0,1,1-1.4A5.58,5.58,0,0,1,4,1.6a5.69,5.69,0,0,1,1.66-.55A11.83,11.83,0,0,1,7.54.89H132.08a11.58,11.58,0,0,1,1.86.16,5.85,5.85,0,0,1,1.67.55,5.34,5.34,0,0,1,1.4,1,5.68,5.68,0,0,1,1.52,3.05,11.85,11.85,0,0,1,.18,1.88V32.47a12.72,12.72,0,0,1-.17,1.85A5.89,5.89,0,0,1,138,36a5.71,5.71,0,0,1-1,1.39,5.12,5.12,0,0,1-1.4,1,5.75,5.75,0,0,1-1.67.55,11.7,11.7,0,0,1-1.87.16H8.44Z",
  transform: "translate(-0.02)"
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "140.62px",
    height: "41px",
    viewBox: "0 0 140.62 41"
  }, props), React.createElement("path", {
    d: "M130.09,0H7.52a13.39,13.39,0,0,0-2,.18,6.74,6.74,0,0,0-1.9.63A6.11,6.11,0,0,0,2,2,6.07,6.07,0,0,0,.82,3.62a6.74,6.74,0,0,0-.63,1.9,12.18,12.18,0,0,0-.17,2v25a12.18,12.18,0,0,0,.17,2,6.8,6.8,0,0,0,.63,1.91A6,6,0,0,0,2,38a6.07,6.07,0,0,0,1.62,1.18,6.74,6.74,0,0,0,1.9.63,13.39,13.39,0,0,0,2,.18H132.1a13.39,13.39,0,0,0,2-.18,7.14,7.14,0,0,0,1.91-.63A6,6,0,0,0,137.62,38a6.28,6.28,0,0,0,1.19-1.61,6.76,6.76,0,0,0,.61-1.91,12.2,12.2,0,0,0,.19-2v-25a12.2,12.2,0,0,0-.19-2,6.7,6.7,0,0,0-.61-1.9A6.33,6.33,0,0,0,137.62,2,6.07,6.07,0,0,0,136,.82a7.07,7.07,0,0,0-1.9-.63,13.39,13.39,0,0,0-2-.18h-2Z",
    transform: "translate(-0.02)",
    style: {
      "fill": "#a6a6a6"
    }
  }), _ref, React.createElement("path", {
    d: "M42.12,14.75H38.41V8.8h.92v5.1h2.79Z",
    transform: "translate(-0.02)",
    style: {
      "fill": "#fff"
    }
  }), React.createElement("path", {
    d: "M43.21,8.93a.55.55,0,0,1,.55-.55h0a.55.55,0,1,1,.15,1.09h-.15a.56.56,0,0,1-.57-.53Zm.13,1.33h.88v4.49h-.88Z",
    transform: "translate(-0.02)",
    style: {
      "fill": "#fff"
    }
  }), React.createElement("path", {
    d: "M47.3,10.17c1,0,1.67.47,1.76,1.26h-.85c-.08-.33-.4-.54-.91-.54s-.87.24-.87.59.23.44.72.55l.74.17c.86.2,1.26.57,1.26,1.23,0,.84-.79,1.41-1.86,1.41s-1.77-.48-1.85-1.28h.89c.11.35.44.56,1,.56s.94-.25.94-.61-.21-.44-.66-.54l-.78-.19c-.86-.2-1.25-.58-1.25-1.25A1.59,1.59,0,0,1,47.3,10.17Z",
    transform: "translate(-0.02)",
    style: {
      "fill": "#fff"
    }
  }), React.createElement("path", {
    d: "M51.52,9.14v1.14h1V11h-1v2.31c0,.47.19.67.63.67h.34v.74a1.93,1.93,0,0,1-.48,0c-1,0-1.38-.35-1.38-1.22V11h-.71v-.75h.71V9.14Z",
    transform: "translate(-0.02)",
    style: {
      "fill": "#fff"
    }
  }), React.createElement("path", {
    d: "M57.42,13.54a1.82,1.82,0,0,1-2,1.3,2,2,0,0,1-2.09-1.9,2,2,0,0,1,0-.42,2.07,2.07,0,0,1,1.77-2.33l.3,0c1.25,0,2,.86,2,2.27v.31H54.3v.05a1.19,1.19,0,0,0,1.1,1.28h.1a1.09,1.09,0,0,0,1.07-.54ZM54.3,12.09h2.27a1.09,1.09,0,0,0-1-1.16h-.11a1.14,1.14,0,0,0-1.16,1.14Z",
    transform: "translate(-0.02)",
    style: {
      "fill": "#fff"
    }
  }), React.createElement("path", {
    d: "M58.67,10.26h.86V11h.06a1.36,1.36,0,0,1,1.35-.8,1.46,1.46,0,0,1,1.56,1.35,1.15,1.15,0,0,1,0,.32v2.91H61.6V12.07c0-.73-.31-1.09-1-1.09a1,1,0,0,0-1.08.92,1.62,1.62,0,0,0,0,.22v2.63h-.89Z",
    transform: "translate(-0.02)",
    style: {
      "fill": "#fff"
    }
  }), React.createElement("path", {
    d: "M66.09,12.5a2.13,2.13,0,1,1,4.24-.41,2.8,2.8,0,0,1,0,.41,2.13,2.13,0,1,1-4.24.41A2.8,2.8,0,0,1,66.09,12.5Zm3.33,0c0-1-.44-1.54-1.21-1.54S67,11.53,67,12.5s.43,1.55,1.2,1.55S69.42,13.48,69.42,12.5Z",
    transform: "translate(-0.02)",
    style: {
      "fill": "#fff"
    }
  }), React.createElement("path", {
    d: "M71.53,10.26h.86V11h.06a1.36,1.36,0,0,1,1.34-.8,1.46,1.46,0,0,1,1.57,1.34,1.22,1.22,0,0,1,0,.33v2.91h-.89V12.07c0-.73-.31-1.09-1-1.09a1,1,0,0,0-1.08.92,1.62,1.62,0,0,0,0,.22v2.63H71.5Z",
    transform: "translate(-0.02)",
    style: {
      "fill": "#fff"
    }
  }), React.createElement("path", {
    d: "M27.58,18.55c-4.09-2.4-10.74-2.62-14.6-1.45a1.17,1.17,0,0,1-.79-2.21l.11,0h0c4.44-1.35,11.82-1.09,16.49,1.68a1.16,1.16,0,0,1,.41,1.6A1.19,1.19,0,0,1,27.58,18.55Zm-.14,3.56a1,1,0,0,1-1.33.33h0A16.43,16.43,0,0,0,13.57,21,1,1,0,0,1,13,19.1h0a18.35,18.35,0,0,1,14.13,1.66A1,1,0,0,1,27.44,22.11Zm-1.53,3.43a.78.78,0,0,1-1.08.26h0c-2.95-1.81-6.67-2.24-11-1.21a.79.79,0,0,1-.94-.59.78.78,0,0,1,.58-.94h0c4.79-1.09,8.89-.62,12.21,1.41a.77.77,0,0,1,.28,1ZM20.15,7.41A12.58,12.58,0,1,0,32.71,20h0A12.57,12.57,0,0,0,20.15,7.41Z",
    transform: "translate(-0.02)",
    style: {
      "fill": "#1ed760",
      "fillRule": "evenodd"
    }
  }), React.createElement("path", {
    d: "M90.77,31.57a1.39,1.39,0,1,1,0-2.78h0a1.39,1.39,0,1,1,0,2.78h0m0-2.64a1.24,1.24,0,0,0-1.24,1.22v.05a1.22,1.22,0,0,0,1.18,1.24h.06A1.25,1.25,0,0,0,92,30.19v0a1.21,1.21,0,0,0-1.19-1.23h0m.3,1.4.41.53h-.34l-.37-.5h-.31v.5H90.2V29.39h.63c.34,0,.57.17.57.46a.51.51,0,0,1-.34.48m-.29-.67h-.36v.47h.36c.17,0,.31-.1.31-.24a.27.27,0,0,0-.31-.23",
    transform: "translate(-0.02)",
    style: {
      "fill": "#1dd15d"
    }
  }), React.createElement("path", {
    d: "M43.37,24.68c-2.21-.55-2.61-.9-2.61-1.69s.71-1.23,1.71-1.23a4.91,4.91,0,0,1,3,1.15.17.17,0,0,0,.1,0,.16.16,0,0,0,.1-.08l1-1.51a.21.21,0,0,0,0-.19,6.63,6.63,0,0,0-4.22-1.49c-2.38,0-4.09,1.45-4.09,3.48s1.44,3,3.92,3.58c2.1.51,2.47.9,2.47,1.61s-.68,1.3-1.82,1.3a5.12,5.12,0,0,1-3.52-1.45.17.17,0,0,0-.1,0,.2.2,0,0,0-.1.08l-1.2,1.44c-.07.07,0,.13,0,.19a7.21,7.21,0,0,0,4.85,1.88c2.58,0,4.21-1.4,4.21-3.58,0-1.85-1-2.86-3.74-3.49",
    transform: "translate(-0.02)",
    style: {
      "fill": "#1dd15d"
    }
  }), React.createElement("path", {
    d: "M52.92,22.5a3.46,3.46,0,0,0-2.77,1.34v-1a.14.14,0,0,0-.13-.13h-2a.15.15,0,0,0-.14.13V34.07a.15.15,0,0,0,.14.13h2a.14.14,0,0,0,.13-.13V30.49a3.59,3.59,0,0,0,2.76,1.27c2,0,4.16-1.57,4.16-4.62S55,22.5,52.92,22.5m1.88,4.61a2.37,2.37,0,0,1-2.09,2.6h-.22a2.46,2.46,0,0,1-2.37-2.55v-.06a2.36,2.36,0,0,1,4.68-.54,2.44,2.44,0,0,1,0,.54",
    transform: "translate(-0.02)",
    style: {
      "fill": "#1dd15d"
    }
  }), React.createElement("path", {
    d: "M62.44,22.5a4.63,4.63,0,1,0,4.72,4.62A4.58,4.58,0,0,0,62.6,22.5h-.16m0,7.27A2.51,2.51,0,0,1,60,27.22v-.1a2.45,2.45,0,0,1,2.28-2.62h.17A2.54,2.54,0,0,1,64.93,27s0,.07,0,.11a2.47,2.47,0,0,1-2.32,2.61h-.16",
    transform: "translate(-0.02)",
    style: {
      "fill": "#1dd15d"
    }
  }), React.createElement("path", {
    d: "M72.84,22.67H70.67V20.46a.13.13,0,0,0-.13-.12h-2a.14.14,0,0,0-.13.12v2.21H67.5a.13.13,0,0,0-.13.13v1.69a.13.13,0,0,0,.13.13h.93V29a2.33,2.33,0,0,0,2,2.67,2,2,0,0,0,.65,0,3.3,3.3,0,0,0,1.84-.46.17.17,0,0,0,.07-.13V29.5a.17.17,0,0,0-.07-.13.11.11,0,0,0-.13,0,2.17,2.17,0,0,1-1.17.27c-.63,0-.9-.31-.9-.94V24.6h2.17a.13.13,0,0,0,.13-.13V22.79c0-.07,0-.13-.14-.13",
    transform: "translate(-0.02)",
    style: {
      "fill": "#1dd15d"
    }
  }), React.createElement("path", {
    d: "M80.41,22.67v-.22c0-.8.3-1.17,1-1.17a3,3,0,0,1,1.11.19.15.15,0,0,0,.13,0,.17.17,0,0,0,.07-.13V19.59c0-.07,0-.12-.1-.12A6,6,0,0,0,81,19.23c-1.81,0-2.78,1-2.78,3v.41h-.94a.14.14,0,0,0-.13.13v1.74a.13.13,0,0,0,.13.13h.94v6.77a.15.15,0,0,0,.13.13h2a.13.13,0,0,0,.12-.13V24.67h1.84l2.81,6.76c-.33.7-.63.84-1.07.84A2.17,2.17,0,0,1,83,32a.07.07,0,0,0-.1,0h0a.14.14,0,0,0-.1.07l-.66,1.47a.27.27,0,0,0,.06.21,4.25,4.25,0,0,0,2.12.53c1.47,0,2.27-.66,3-2.51l3.42-8.82v-.14a.21.21,0,0,0-.13-.07h-2c-.07,0-.1,0-.13.1l-2.11,6-2.38-6a.12.12,0,0,0-.13-.1Z",
    transform: "translate(-0.02)",
    style: {
      "fill": "#1dd15d"
    }
  }), React.createElement("path", {
    d: "M76,22.67h-2a.16.16,0,0,0-.14.13v8.61a.16.16,0,0,0,.14.13h2a.14.14,0,0,0,.13-.13V22.8c0-.07,0-.13-.13-.13",
    transform: "translate(-0.02)",
    style: {
      "fill": "#1dd15d"
    }
  }), React.createElement("path", {
    d: "M75.06,18.75a1.42,1.42,0,1,0-.24,2.82h.24a1.4,1.4,0,0,0,1.39-1.4,1.43,1.43,0,0,0-1.4-1.42",
    transform: "translate(-0.02)",
    style: {
      "fill": "#1dd15d"
    }
  }));
};

export default __webpack_public_path__ + "static/media/listen-spotify.d042f5c5.svg";
export { SvgComponent as ReactComponent };